<app-panel-header-image-view [pretitle]="preTitle | transloco" [title]="title | transloco" [banner_image]="headerImage">
  <app-third-nav-tab-component [elements]="routes"></app-third-nav-tab-component>
</app-panel-header-image-view>
<app-app-content-page-wrapper class="hide">
  <app-google-ads [type]="'double_click_WA122_SANLIDA'" [style.display]="activeRoute"></app-google-ads>
  <router-outlet></router-outlet>
</app-app-content-page-wrapper>
